export const settings = {
    // 0 = Aucune recherche, je suis embauché, 1 = Recherche de travail, 2 = Recherche de Mission
    SearchingFor: 2,
    entreprise: "",
    poste: 'fullstack',
    exps: [
        {
            id: 'Bac',
            img: './charles-poncet.jpg',
            imgTitle: 'Lycée Charle Poncet',
            modalTitle: 'modalTitleBac',
            modalDesc: 'modalDescBac',
            yearStart: "2016",
            yearEnd: "2018",
            monthStart: "",
            monthEnd: "",
            skills: []
        },
        {
            id: 'DUT',
            img: './iut-dijon.jpg',
            imgTitle: 'IUT Dijon',
            modalTitle: 'modalTitleDUT',
            modalDesc: 'modalDescDUT',
            yearStart: "2018",
            yearEnd: "2020",
            monthStart: "",
            monthEnd: "",
            skills: ['HTML', 'CSS', 'JavaScript', 'Photoshop', 'Illustrator', 'Premiere Pro', 'MySQL', 'Animation JS', 'WordPress']
        },
        {
            id: 'Licence',
            img: './licence.png',
            imgTitle: 'Licence DDIM',
            modalTitle: 'modalTitleLicence',
            modalDesc: 'modalDescLicence',
            yearStart: "2020",
            yearEnd: "2021",
            monthStart: "",
            monthEnd: "",
            skills: ['Three', 'PixiJS', 'Node', 'JavaScript', 'Travail en équipe', 'MySQL', 'PHP', 'SocketIO']
        },
        {
            id: 'Sandwich',
            img: './rectorat.jpg',
            imgTitle: 'Rectorat de Dijon',
            modalTitle: 'modalTitleSandwich',
            modalDesc: 'modalDescSandwich',
            yearStart: "2020",
            yearEnd: "2021",
            monthStart: "9",
            monthEnd: "9",
            skills: ['React', 'Svelte', 'Git', 'Node', 'JavaScript', 'Travail en équipe', 'API', "Méthodologie AGILE", 'Figma']
        },
        {
            id: 'AnthroPi',
            modalTitle: 'modalTitleAnthroPi',
            modalDesc: 'modalDescAnthroPi',
            yearStart: "2021",
            yearEnd: "2025",
            monthStart: "9",
            monthEnd: "3",
            skills: ['Angular', 'TypeScript', 'Git', 'Docker', 'NodeJS', 'JavaScript', 'Travail en équipe', 'API', "Méthodologie AGILE", 'SocketIO', 'PeerJS', 'Gitlab CI', 'Figma']
        },
        {
            id: 'Alteca',
            modalTitle: 'modalTitleAlteca',
            modalDesc: 'modalDescAlteca',
            yearStart: "2025",
            yearEnd: "",
            monthStart: "3",
            monthEnd: "",
            skills: ['React', 'Java', 'Git', 'Docker', 'Travail en équipe', "Méthodologie AGILE", 'Gitlab CI', 'Figma', 'IntelliJ']
        }
    ],
    creationsArray: [
        {
            src: "creations-gallery/Chimere.jpg",
            width: 2,
            height: 2,
            type: 'design',
            expsid: 'DUT'
        },
        {
            src: "creations-gallery/anamorphose.png",
            width: 1,
            height: 1,
            type: 'design',
            expsid: 'DUT'
        },
        {
            src: "creations-gallery/Detournement.jpg",
            width: 3,
            height: 2,
            type: 'design',
            expsid: 'DUT'
        },
        {
            src: "creations-gallery/CCAPhoto.PNG",
            width: 50,
            height: 28,
            type: 'web',
            expsid: 'DUT'
        },
        {
            src: "creations-gallery/laboite.png",
            width: 3,
            height: 2,
            type: 'web',
            expsid: 'Sandwich'
        },
        {
            src: "creations-gallery/mezig.png",
            width: 1,
            height: 1,
            type: 'web',
            expsid: 'Sandwich'
        },
        {
            src: "creations-gallery/handicapSco.png",
            width: 1,
            height: 1,
            type: 'web',
        },
        {
            src: "creations-gallery/geometry.png",
            width: 1,
            height: 1,
            type: 'game',
            expsid: 'Licence'
        },
        {
            src: "creations-gallery/pong.png",
            width: 2,
            height: 1,
            type: 'game',
            expsid: 'Licence'
        },
        {
            src: "creations-gallery/simulphone.png",
            width: 50,
            height: 28,
            type: 'web',
            expsid: 'AnthroPi'
        },
        {
            src: "creations-gallery/simulforge.png",
            width: 50,
            height: 28,
            type: 'web',
            expsid: 'AnthroPi'
        },
        {
            src: "creations-gallery/divia.png",
            width: 3,
            height: 2,
            type: 'web',
            expsid: 'Alteca'
        },
        {
            src: "creations-gallery/elliot.png",
            width: 20,
            height: 17,
            type: 'web',
        },
    ]
};